import axios from "../axios";
import * as createResponseHandling from "./../responseHandling/create"

async function signUpForCourse(body) {
  const res = await axios.post('/students/course_accesses', body);
  return createResponseHandling.parseResponse(res);
}

export {
  signUpForCourse
};
